import { ALL_UPLOAD_TYPES, DISTRIBUTION_WORKFLOWS } from 'modules/documents/lib/constants'

export type WizardData = {
  distributionWorkflow: DISTRIBUTION_WORKFLOWS
  uploadType: (typeof ALL_UPLOAD_TYPES)[keyof typeof ALL_UPLOAD_TYPES]
  folderId: number | null
  combineFileName?: string
  esignatureRequest: boolean
  additionalSignersAccessIds: number[]
  numberSplitPages: number
  featureFlagDocumentFolderPermissionsEnabled: boolean
}

export const canRenameFile = (type: WizardData['uploadType'], nFiles: number): boolean =>
  (nFiles === 1 &&
    (type === 'split' ||
      type === 'combine' ||
      type === 'manual_per_file' ||
      type === 'manual_per_page')) ||
  (nFiles > 1 && type === 'combine')
